// Module
var code = `<div class="transfer-field"> <component-field></component-field> <component-button></component-button> </div> `;
// Exports
export default code;